import { Anotation } from "../anotation/anotation.component"

interface FipeAveragesProps {
    prices: {
        new: number
        used: number
    }
    isVehicle0km: boolean
    isVehicleArmored: boolean
}

export const FipeAverages = ({ isVehicle0km, isVehicleArmored, prices }: Readonly<FipeAveragesProps>) => {
    if (isVehicle0km && prices.new) return <span id="fipe-price" data-testid="fipe-price">{prices.new}</span>;

    if (isVehicleArmored || isVehicle0km && !prices.new || !prices.used || !prices.new && !prices.used) {
        return <Anotation text="Sem valores de referência. Veja a média Webmotors" />;
    }

    return <span>{prices.used}</span>;
}